// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { productBrandStyles } from "@vanmeter/Overrides/Components/ProductBrand";
import { fontConfig } from "@vanmeter/XDL/constants";
import { css } from "styled-components";

const sharedTextStyle: TypographyPresentationProps = {
    ellipsis: true,
    ...fontConfig.xSmallSingleLine,
    css: css`
        letter-spacing: 0;
        margin-bottom: 2px;
    `,
};

productBrandStyles.nameLink = {
    typographyProps: {
        ...sharedTextStyle,
    },
    css: css`
        @media print {
            display: block;
        }
    `,
};
productBrandStyles.nameText = {
    ...sharedTextStyle,
};

productBrandStyles.hiddenContainer = {
    css: css`
        height: 16px;
        margin-bottom: 2px;
    `,
};
